import { getStorage, setStorage } from '../../utils/stroage/stroage'
import {
  __VC_LIST__,
  __VC_ID__,
  __TRADE_CONFIG__,
  __COIN_LIST_WITH_PRICE__
} from '../../utils/stroage/nameSpace'
import {
  SET_VC_ID,
  SET_TRADE_CONFIG,
  SET_VC_LIST,
  SET_COIN_LIST_WITH_PRICE
} from '../nameSpace'
import { checkCacheVersionIsRight, findTargetUpdateTimeByKey, initStateInCacheHas } from '../../utils/cache'
import { vcTimingTradeConfig } from '../../api/vcTimingTradeConfig/vcTimingTradeConfig'
import { vcList, vcMarketList } from '../../api/vc/vc'
import {formatNumberToPercent} from '../../utils/utils'

export default {
  state: {
    vcId: getStorage(__VC_ID__, !0) || '',
    tradeConfig: initStateInCacheHas(__TRADE_CONFIG__),
    vcList: initStateInCacheHas(__VC_LIST__),
    coinListWithPrice: getStorage(__COIN_LIST_WITH_PRICE__) || []
  },
  mutations: {
    [ SET_COIN_LIST_WITH_PRICE ] (state, coinListWithPrice) {
      state.coinListWithPrice = coinListWithPrice
      setStorage(__COIN_LIST_WITH_PRICE__, coinListWithPrice)
    },
    [ SET_VC_LIST ] (state, vcList) {
      state.vcList = vcList
      setStorage(__VC_LIST__, vcList)
    },
    [ SET_VC_ID ] (state, vcId) {
      state.vcId = vcId
      setStorage(__VC_ID__, vcId)
    },
    [ SET_TRADE_CONFIG ] (state, tradeConfig) {
      state.tradeConfig = tradeConfig
      setStorage(__TRADE_CONFIG__, tradeConfig)
    }
  },
  actions: {
    /***
     * 获取带价格行情的币种列表
     * @param commit
     * @returns {Promise<unknown>}
     */
    getCoinListWithPrice ({ commit }) {
      return new Promise((resolve, reject) => {
        vcMarketList({})
          .then(res => {
            if (res.success) {
              commit(SET_COIN_LIST_WITH_PRICE, res.data.map(coinItem => {
                return {
                  ...coinItem,
                  changePerStr: formatNumberToPercent(coinItem.l)
                }
              }))
            }
            return resolve()
          })
          .catch(reject)
      })
    },
    setVcId ({
      commit,
      getters,
      dispatch
    }, vcId) {
      return new Promise((resolve, reject) => {
        if (!vcId) return reject('No Such vcId')
        commit(SET_VC_ID, vcId)
        return resolve()
        /* if (!getters.tradeConfig.length) {
          dispatch('getTradeConfig').then(tradeConfig => {
            if (tradeConfig.find(vcConfig => vcConfig.vcId === vcId)) {
              commit(SET_VC_ID, vcId)
              return resolve(vcId)
            } else {
              return reject(new Error('该币种暂时无法交易'))
            }
          })
        } else {
          if (getters.tradeConfig.find(vcConfig => vcConfig.vcId === vcId)) {
            commit(SET_VC_ID, vcId)
            return resolve(vcId)
          } else {
            return reject(new Error('该币种暂时无法交易'))
          }
        } */
      })
    },
    getTradeConfig ({
        commit,
        state,
        getters,
        dispatch
      }, { noCache } = {}) {
      return new Promise((resolve, reject) => {
        if (!noCache && checkCacheVersionIsRight(state.tradeConfig)) {
          return resolve(getters.tradeConfig)
        } else {
          vcTimingTradeConfig({})
            .then(res => {
              if (res.success) {
                const { data: tradeConfig } = res
                commit(SET_TRADE_CONFIG, {
                  ...state.tradeConfig,
                  [`value_${getters.locale}`]: {
                    data: tradeConfig,
                    finishUpdateTime: findTargetUpdateTimeByKey(__TRADE_CONFIG__)
                  }
                })
                if (!getters.vcId) {
                  dispatch('setVcId', tradeConfig[0]['vcId'])
                }
                return resolve(tradeConfig)
              } else {
                return reject(new Error(res.message))
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      })
    },
    getVcList ({
        commit,
        state,
        getters,
        dispatch
      }, { noCache } = {}) {
      return new Promise((resolve, reject) => {
        if (!noCache && checkCacheVersionIsRight(state.vcList)) {
          return resolve(getters.vcList)
        } else {
          vcList({})
            .then(res => {
              if (res.success) {
                const { data: vcList } = res
                commit(SET_VC_LIST, {
                  ...state.vcList,
                  [`value_${getters.locale}`]: {
                    data: vcList,
                    finishUpdateTime: findTargetUpdateTimeByKey(__VC_LIST__)
                  }
                })
                setTimeout(() => {
                  return resolve(vcList)
                }, 0)
              } else {
                return reject(new Error(res.message))
              }
            })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vc.js